"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formToApiForm = void 0;
var ListPropertyApiToken_1 = require("@/api/remote/protected/ListPropertyApiToken");
var ListPropertyAvailability_1 = require("@/pages/listProperty/states/ListPropertyAvailability");
var ListPropertyFeature_1 = require("@/pages/listProperty/states/ListPropertyFeature");
var toRentAvailability = function (rentAvailableType) {
    if (rentAvailableType === ListPropertyAvailability_1.ListPropertyAvailability.RENT_AVAILABLE)
        return ListPropertyApiToken_1.ListPropertyRentAvailability.Immediately;
    return ListPropertyApiToken_1.ListPropertyRentAvailability.SelectDate;
};
var toSellStatus = function (saleAvailableType) {
    if (saleAvailableType === ListPropertyAvailability_1.ListPropertyAvailability.SALE_OCCUPIED)
        return ListPropertyApiToken_1.ListPropertySellStatus.Occupied;
    if (saleAvailableType === ListPropertyAvailability_1.ListPropertyAvailability.SALE_TENANTED)
        return ListPropertyApiToken_1.ListPropertySellStatus.Tenanted;
    return ListPropertyApiToken_1.ListPropertySellStatus.Vacant;
};
var toListPropertyFeatureApi = function (feature) {
    switch (feature) {
        case ListPropertyFeature_1.ListPropertyFeature.BALCONY: return ListPropertyApiToken_1.ListPropertyFeatureApi.Balcony;
        case ListPropertyFeature_1.ListPropertyFeature.TERRACE: return ListPropertyApiToken_1.ListPropertyFeatureApi.Terrace;
        case ListPropertyFeature_1.ListPropertyFeature.ROOFTOP: return ListPropertyApiToken_1.ListPropertyFeatureApi.Rooftop;
        case ListPropertyFeature_1.ListPropertyFeature.GARDEN: return ListPropertyApiToken_1.ListPropertyFeatureApi.Garden;
        case ListPropertyFeature_1.ListPropertyFeature.CAR_PARK: return ListPropertyApiToken_1.ListPropertyFeatureApi.CarPark;
        case ListPropertyFeature_1.ListPropertyFeature.MAIDS_ROOM: return ListPropertyApiToken_1.ListPropertyFeatureApi.MaidsRoom;
        case ListPropertyFeature_1.ListPropertyFeature.PRIVATE_POOL: return ListPropertyApiToken_1.ListPropertyFeatureApi.PrivatePool;
    }
};
exports.formToApiForm = function (form) {
    return {
        address: form.buildingName,
        bathroom: form.baths,
        bedroom: form.beds,
        comments: form.comments,
        consentToAdvertise: form.clientConsent,
        email: form.clientEmail,
        features: form.features.map(toListPropertyFeatureApi),
        listType: form.listingType,
        name: form.clientName,
        phone: form.clientPhone,
        price: form.priceHkd,
        receiveUpdates: form.clientSubscribed,
        rentAvailability: toRentAvailability(form.rentAvailableType),
        sellStatus: toSellStatus(form.saleAvailableType),
        rentAvailabilityDate: form.rentAvailbleDate,
    };
};
